import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/layout.tsx");
